import { History } from './model';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
// import { FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HistoryServiceService } from './history-service.service';
import * as fileSaver from 'file-saver';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HistoryComponent implements OnInit {
  displayedColumns: string[] = ['select', 'date', 'xraydate', 'patient_name', 'hospital_number', 'result', 'action'];
  // dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  // selection = new SelectionModel<PeriodicElement>(true, []);
  pipe: DatePipe;
  selection = new SelectionModel<History>(true, []);
  dataSource;
  seleted: any = [];
  selectionAmount: number;
  filteredEvents: any;
  haveValue: boolean = true
  viewInfo: any;
  msg_export_error: string
  msg_export_success: string
  toggle = new FormControl();

  historys: any[];
  data: any
  data_sort: any

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild('ref', { static: true }) ref: any;

  constructor(
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private http: HttpClient,
    private service_history: HistoryServiceService,
    public _snackBar: MatSnackBar
  ) {
    this.pipe = new DatePipe('en');
  }

  ngOnInit() {
    this.getAllHistory()
  }

  getAllHistory() {
    this.service_history.getHistoryAll().subscribe(historys => {
      // console.log(historys);
      this.historys = historys
      this.data = Object.assign(this.historys);
      this.dataSource = new MatTableDataSource(this.historys)
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getPhoto(item: any) {
    this.viewInfo = item;
    // console.log(this.viewInfo);
    // this.viewInfo['default_filename'] = file_name['default_filename']
    localStorage.setItem('viewInfo', JSON.stringify(this.viewInfo))
    const dialogRef = this.dialog.open(dialog_view, {
      width: '60%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getAllHistory()
      this.viewInfo = []
      localStorage.removeItem('viewInfo')
    })
  }

  private findStartEndIndices(): { startIndex: number, endIndex: number } {
    if (this.dataSource) {
      const pageIndex = this.dataSource.paginator.pageIndex;
      const pageSize = this.dataSource.paginator.pageSize;
      const total = this.dataSource.paginator.length;
      const startIndex = pageIndex * pageSize;
      const endIndex = (startIndex + pageSize) > total ? total : startIndex + pageSize;
      return { startIndex: startIndex, endIndex: endIndex };
    }
  }

  isAllSelected() {
    const page: { startIndex: number, endIndex: number } = this.findStartEndIndices();
    if (this.dataSource) {
      const sortedData = this.dataSource._orderData(this.dataSource.data);
      const numSelected = sortedData.slice(page.startIndex, page.endIndex)
        .filter(row => this.selection.isSelected(row)).length;

      return numSelected === (page.endIndex - page.startIndex);
    }
  }

  isAtLeaseOneSelected() {
    const page: { startIndex: number, endIndex: number } =
      this.findStartEndIndices();
    if (this.dataSource) {
      const sortedData = this.dataSource._orderData(this.dataSource.data);
      const numSelected = sortedData.slice(page.startIndex, page.endIndex)
        .filter(row => this.selection.isSelected(row)).length;
      return numSelected > 0;
    }
  }


  masterToggle() {
    const page: { startIndex: number, endIndex: number } = this.findStartEndIndices();

    const sortedData = this.dataSource._orderData(this.dataSource.data);

    if (this.isAllSelected()) {
      sortedData.slice(page.startIndex, page.endIndex).forEach(row => {
        this.selection.deselect(row);
        // this.button_All = true
      });
    }

    else {
      sortedData.slice(page.startIndex, page.endIndex).forEach(row => {
        this.selection.select(row);
        // this.button_All = false
      });
    }
  }


  rowToggle(row) {
    this.selection.toggle(row);
    row.selected = !row.selected;

    // console.log(!row.selected)
  }

  // removeSelectedRows() {
  //   this.selection.selected.forEach(item => {
  //     this.seleted.push(item['upload_id'])
  //     localStorage.setItem('seleted', JSON.stringify(this.seleted))
  //     let index: number = this.data.findIndex(d => d === item);
  //     console.log(this.data.findIndex(d => d === item));
  //     this.data.splice(index, 1)
  //     this.dataSource = new MatTableDataSource(this.data);
  //     this.dataSource.paginator = this.paginator;
  //   });
  //   this.selection = new SelectionModel(true, []);
  // }


  // Dialog Delete
  Dialog_Delete(): void {
    this.selection.selected.forEach(item => {
      this.seleted.push(item['upload_id'])
      localStorage.setItem('seleted', JSON.stringify(this.seleted))
    });
    const dialogRef = this.dialog.open(dialog_delete, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getAllHistory()
      this.selection.clear();
      localStorage.removeItem('seleted')
      this.seleted = []
      this.toggle.setValue(false)
      this.haveValue = true
    })
  }

  // dialog export
  dialog_export(): void {
    const dialogRef = this.dialog.open(dialog_export, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    })
  }

}


@Component({
  selector: 'dialog_delete',
  templateUrl: 'dialog-delete.html',
  styleUrls: ['history.component.scss']
})
export class dialog_delete implements OnInit {
  seleted = JSON.parse(localStorage.getItem('seleted'));
  message = "Delete Sussecc!"
  action = "Done"
  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  delHistoryApi = `${environment.apiUrl}/history`;

  constructor(
    public dialogRef: MatDialogRef<dialog_delete>,
    private http: HttpClient,
    // private route: Router,
    public _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteHistory() {
    this.http.delete(`${this.delHistoryApi}?upload_id=${this.seleted}`, this.httpOptions).subscribe(data => {
      console.log('Delete Success', data);
      this.seleted = []
      localStorage.removeItem('seleted')
      this._snackBar.open(this.message, this.action, {
        duration: 5000,
      });
      this.onNoClick()
    }, error => {
      // this.seleted = []
      // localStorage.removeItem('seleted')
      this._snackBar.open("Delete fail!", this.action, {
        duration: 5000,
      });
      console.log('Error: ', error.error.message);
    });
  }

}

@Component({
  selector: 'dialog_view',
  templateUrl: 'dialog-view.html',
  styleUrls: ['history.component.scss']
})
export class dialog_view implements OnInit {
  viewInfo = JSON.parse(localStorage.getItem('viewInfo'));
  feedbackAPI = `${environment.apiUrl}/history/feedback`
  feedback: any

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_view>,
    public _snackBar: MatSnackBar,
    private http: HttpClient,
  ) {
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  input_feedback(input: any) {
    this.feedback = input
    // console.log(input);
  }

  updata_feedback() {
    this.http.put(this.feedbackAPI, {
      feedback: this.feedback,
      upload_id: this.viewInfo['upload_id']
    }, this.httpOptions).subscribe(res => {
      // console.log(res);
      // this.diagInfos[i]['feedback'] = this.feedback;
      // this.comment_than = false
      // this.feedback = ''
      this._snackBar.open("Update feedback success.", 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open("Update feedback fail!.", 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_export',
  templateUrl: 'dialog-export.html',
  styleUrls: ['history.component.scss']
})
export class dialog_export implements OnInit {
  exportApi = `${environment.apiUrl}/history/xlsx`;
  formExport: FormGroup;
  message = "Export fail!"
  action = "Done"

  results: string[] = ['normal', 'Tuberculosis', 'Pneumothorax', 'Emphysema', 'abnormal'];

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_export>,
    private datePipe: DatePipe,
    private http: HttpClient,
    public formBuilder: FormBuilder,
    public _snackBar: MatSnackBar
  ) {
    this.formExport_to_csv()
  }

  ngOnInit() {

  }

  private formExport_to_csv() {
    this.formExport = this.formBuilder.group({
      hospital_id: [''],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      select: [[], Validators.required],
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getExport() {
    // console.log(this.formExport.value);
    this.formExport.controls['start_date'].setValue(this.datePipe.transform(this.formExport.value.start_date, 'dd/MM/yyyy'))
    this.formExport.controls['end_date'].setValue(this.datePipe.transform(this.formExport.value.end_date, 'dd/MM/yyyy'))
    this.formExport.controls['hospital_id'].setValue(localStorage.getItem('hospital_id'))
    // console.log(this.formExport.value);
    const today = this.datePipe.transform(Date.now(), 'dd/MM/yyyy');
    this.http.post(this.exportApi, this.formExport.value
      , { headers: this.headers, responseType: 'blob' as 'json', observe: 'response' }).subscribe(data => {
        const blob = (data['body']);
        const filename = "report_cxr_" + today + ".xlsx"
        fileSaver.saveAs(blob, filename);
        // console.log(data);
        this.onNoClick()
        this._snackBar.open('Export success.', 'Done', {
          duration: 3000,
        });
      }, response => {
        console.log("Error: ", response);
        this._snackBar.open(this.message, this.action, {
          duration: 3000,
        });
      });
  }

}

function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
